'use client'

import type { SearchSuggestionsResultsProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useSearchSuggestionsResults } from '@maestro/commerce-blocks/components/search-bar/batons/use-search-suggestions-results'
import { getSearchOptionId } from '@maestro/commerce-blocks/utils/search.utils'
import { Link } from '@pearlconvert/ui/components/link'

export default function SearchSuggestionsResults({
  suggestions,
  removalMessage,
  handleSuggestionSelectAction,
  activeOptionId,
}: SearchSuggestionsResultsProps) {
  const { handleClickSuggestion } = useSearchSuggestionsResults({
    removalMessage,
    handleSuggestionSelectAction,
  })

  return (
    <div className="searchbar__suggestions-node">
      <ul className="searchbar__suggestions-list">
        {suggestions.map((result, idx) => {
          const searchUrl = `/search/?text=${result.query}`
          const optionId = getSearchOptionId('results', result.query, idx)

          return (
            <li
              className="searchbar__suggestions-list-item"
              key={`SearchSuggestionsResults-${idx}`}
              id={optionId}
              role="option"
              aria-selected={activeOptionId === optionId}
            >
              <Link
                className="searchbar__suggestions-list-link"
                href={searchUrl}
                tabIndex={-1}
                dangerouslySetInnerHTML={{
                  __html: result.highlight!,
                }}
                onClick={() => handleClickSuggestion(result.query, searchUrl)}
              ></Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
